import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";
import "../css/terms.scss";

function Terms() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="terms info-page" id="main-content">
      <div className="info-shell info-shell--narrow">
        <nav className="info-breadcrumb" aria-label="Breadcrumb">
          <Link to="/" onClick={scrollToTop}>Home</Link>
          <span aria-hidden="true">/</span>
          <span aria-current="page">Terms</span>
        </nav>

        <header className="info-page__header info-page__hero">
          <p className="info-page__eyebrow">The practical details</p>
          <h1>Terms of use and sale.</h1>
          <p className="info-page__lead">
            These terms set out the agreement between you and {siteConfig.legalName},
            trading as {siteConfig.brandName}, when you use this storefront or
            place an order.
          </p>
          <p className="info-page__updated">Last updated · September 2026</p>
        </header>

        <div className="terms__notice">
          <p>
            Please read these terms before ordering. Your statutory consumer
            rights are not reduced or replaced by anything written here.
          </p>
          <p>
            Store operator: <strong>{siteConfig.legalName}</strong><br />
            {siteConfig.contact.address}
          </p>
        </div>

        <article className="info-page__article terms__sections">
          <section>
            <p className="info-page__eyebrow">01</p>
            <h2>Using this storefront</h2>
            <p>
              You may browse and purchase for personal, lawful use. Do not
              interfere with the storefront, attempt unauthorised access, copy
              content at scale or use the service in a way that harms other
              customers or our operations.
            </p>
          </section>

          <section>
            <p className="info-page__eyebrow">02</p>
            <h2>Products and availability</h2>
            <p>
              We aim to present colours, dimensions and descriptions accurately,
              but screens and natural materials can introduce small variations.
              Products remain subject to availability until an order is accepted.
              If an item becomes unavailable, we will explain the options and
              return any affected payment.
            </p>
          </section>

          <section>
            <p className="info-page__eyebrow">03</p>
            <h2>Orders and acceptance</h2>
            <p>
              Submitting checkout is an offer to purchase. An automatic receipt
              confirms that we received the request; the sales contract is formed
              when we accept and dispatch the order, unless local law states
              otherwise. We may decline an order for legitimate reasons such as
              stock errors, payment failure or suspected misuse.
            </p>
          </section>

          <section>
            <p className="info-page__eyebrow">04</p>
            <h2>Prices and payment</h2>
            <p>
              The checkout displays the applicable item prices, taxes, delivery
              charges and total before payment. Payment must be authorised using
              an available method. Obvious pricing errors may be corrected before
              acceptance, in which case you may confirm or cancel the order.
            </p>
          </section>

          <section>
            <p className="info-page__eyebrow">05</p>
            <h2>Delivery, returns and refunds</h2>
            <p>
              Delivery estimates are not guarantees and may be affected by
              carriers, customs or circumstances outside reasonable control.
              Eligibility, packing and refund guidance is described on our
              dedicated service pages.
            </p>
            <div className="terms__links">
              <Link to="/shipping" onClick={scrollToTop}>Shipping information</Link>
              <Link to="/returns" onClick={scrollToTop}>Returns information</Link>
            </div>
          </section>

          <section>
            <p className="info-page__eyebrow">06</p>
            <h2>Intellectual property</h2>
            <p>
              The storefront design, original text, graphics, product imagery and
              brand identifiers are protected by applicable intellectual-property
              rules. Personal viewing is welcome; commercial reuse requires prior
              written permission.
            </p>
          </section>

          <section>
            <p className="info-page__eyebrow">07</p>
            <h2>Responsibility</h2>
            <p>
              Nothing excludes responsibility that cannot lawfully be excluded.
              Subject to that rule, we are not responsible for losses that were
              not reasonably foreseeable, business losses arising from consumer
              use, or interruptions outside our reasonable control.
            </p>
          </section>

          <section>
            <p className="info-page__eyebrow">08</p>
            <h2>Changes and applicable law</h2>
            <p>
              We may update these terms when the service, law or business changes.
              The version shown when you order applies to that purchase. Applicable
              law and courts are determined by mandatory consumer protections and
              the rules connected to our place of business.
            </p>
          </section>
        </article>

        <section className="info-faq terms__faq" aria-labelledby="terms-help-title">
          <div>
            <p className="info-page__eyebrow">Still unsure?</p>
            <h2 id="terms-help-title">Ask before you order.</h2>
          </div>
          <div className="info-faq__list">
            <details>
              <summary>Which terms apply to my order?</summary>
              <p>The version available at the time you submit the order applies, together with any mandatory rights in your country.</p>
            </details>
            <details>
              <summary>How can I contact the team?</summary>
              <p>Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> or use our contact form.</p>
            </details>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Terms;
